import { useCallback, useEffect, useRef, useState } from 'react';

export default function useFormFeedback(prefix) {
  const [feedback, setFeedback] = useState({ message: '', field: null, attempt: 0 });
  const summaryRef = useRef(null);
  const setError = useCallback((message, field = null) => {
    setFeedback(previous => ({ message, field, attempt: previous.attempt + 1 }));
  }, []);
  useEffect(() => {
    if (!feedback.message) return;
    const target = feedback.field ? document.getElementById(feedback.field) : summaryRef.current;
    target?.focus({ preventScroll: true });
    target?.scrollIntoView?.({ block: 'center', behavior: 'auto' });
  }, [feedback]);
  const fieldProps = id => ({
    id,
    'aria-invalid': Boolean(feedback.message && feedback.field === id),
    'aria-describedby': feedback.message && feedback.field === id ? `${id}-error` : undefined,
  });
  const fieldError = id => feedback.message && feedback.field === id
    ? <p className="form-field-error" id={`${id}-error`}>{feedback.message}</p> : null;
  const errorSummary = feedback.message ? <div className="form-error-summary" id={`${prefix}-errors`} role="alert" tabIndex={-1} ref={summaryRef}>
    <strong>{feedback.message}</strong>
    {feedback.field && <a href={`#${feedback.field}`} onClick={event => {
      event.preventDefault();
      const field = document.getElementById(feedback.field);
      field?.focus();
      field?.scrollIntoView?.({ block: 'center', behavior: 'auto' });
    }}>Go to this field ↑</a>}
  </div> : null;
  return { error: feedback.message, setError, fieldProps, fieldError, errorSummary };
}
